import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Main } from '../core/main.service';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {
    constructor(private httpClient: HttpClient, private mainService: Main, @Inject(Restangular) public Restangular: any) {
    }

    getTransactions(options: string) {
        debugger;
        return this.Restangular.one('transactions?' + options).customGET('');
    }

    getAllTransactions(options: string = null) {
        debugger;
        return this.Restangular.one('transactions?all=true' + options).customGET('');
    }

    getEkubMembers(id: String) {
        debugger;
        return this.Restangular.one('ekubs/' + id + '/members').customGET('');
    }

    getTransactionMembers(id: String) {
        debugger;
        return this.Restangular.one('transactions/' + id + '/members').customGET('');
    }

    getTransaction(id: string) {
        return this.Restangular.one('transactions/' + id).customGET('');
    }

    getTransactionByCategory(options: string) {
        return this.Restangular.one('transactions/category?' + options).customGET('');
    }

    createTransaction(transaction: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('transactions/' + id).customPUT(transaction);
        }
        return this.Restangular.one('transactions').customPOST(transaction);
    }

    changeTransactionStatus(id: string, status: string) {
        return this.Restangular.one(`transactions/${id}/${status}`).customPUT('');
    }

    getOffers(page: number, options: string) {
        return this.Restangular.one('offers?page=' + page + options).customGET('');
    }

    getAllOffers(options: string = null) {
        debugger;
        return this.Restangular.one('offers?all=true' + options).customGET('');
    }

    getAllAwards(filter: string) {
        debugger;
        return this.Restangular.one('awards?all=true' + filter).customGET('');
    }

    getOffer(id: string) {
        return this.Restangular.one('offers/' + id).customGET('');
    }

    createOffer(offer: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('offers/' + id).customPUT(offer);
        }
        return this.Restangular.one('offers').customPOST(offer);
    }

    changeOfferStatus(id: string, status: string) {
        return this.Restangular.one(`offers/${id}/${status}`).customPUT('');
    }

    getSales(page: number, options: string) {
        return this.Restangular.one('sales?page=' + page + options).customGET('');
    }

    getAllSales(options: string = null) {
        debugger;
        return this.Restangular.one('sales?all=true' + options).customGET('');
    }

    getSale(id: string) {
        return this.Restangular.one('sales/' + id).customGET('');
    }

    createSales(sales: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('sales/' + id).customPUT(sales);
        }
        return this.Restangular.one('sales').customPOST(sales);
    }

    changeSaleStatus(id: string, status: string) {
        return this.Restangular.one(`sales/${id}/${status}`).customPUT('');
    }



    getAccounts(page: number, options: string) {
        return this.Restangular.one('accounts?page=' + page + options).customGET('');
    }

    getAllAccounts(options: string = null) {
        debugger;
        return this.Restangular.one('accounts?all=true' + options).customGET('');
    }

    getAccount(id: string) {
        return this.Restangular.one('accounts/' + id).customGET('');
    }

    createAccount(account: object, id: string) {
        debugger;
        if (id != null) {
            return this.Restangular.one('accounts/' + id).customPUT(account);
        }
        return this.Restangular.one('accounts').customPOST(account);
    }

    changeAccountStatus(id: string, status: string) {
        return this.Restangular.one(`accounts/${id}/${status}`).customPUT('');
    }


}
